import { fetchAPI, sendNotification } from '@bsd/dashboard-toolkit/utils'

export const loadGeoObjects = (categoryId) => async (dispatch) => {
  dispatch({ type: 'LOAD_GEO_OBJECTS' })
  try {
    const geoObjects = await fetchAPI(`/in/globe3d/geo-objects?categoryId=${categoryId}`)
    dispatch({ type: 'LOAD_GEO_OBJECTS_SUCCESS', geoObjects })
    return geoObjects
  } catch (error) {
    dispatch({ type: 'LOAD_GEO_OBJECTS_FAIL', error })
  }
}

export const loadGeoObject = (geoObjectId) => async (dispatch) => {
  dispatch({ type: 'LOAD_GEO_OBJECT' })
  try {
    const geoObject = await fetchAPI(`/in/globe3d/geo-objects/${geoObjectId}`)
    dispatch({ type: 'LOAD_GEO_OBJECT_SUCCESS', geoObject })
    return geoObject
  } catch (error) {
    dispatch({ type: 'LOAD_GEO_OBJECT_FAIL', error })
  }
}

export const createGeoObject = (data) => async (dispatch) => {
  dispatch({ type: 'CREATE_GEO_OBJECT' })
  try {
    const geoObject = await fetchAPI(`/in/globe3d/geo-objects`, 'POST', data)
    dispatch({ type: 'CREATE_GEO_OBJECT_SUCCESS', geoObject })
    sendNotification({ level: 'success', message: 'Объект успешно сохранен' })
    return geoObject
  } catch (error) {
    dispatch({ type: 'CREATE_GEO_OBJECT_FAIL', error })
    sendNotification({ level: 'error', message: 'При сохранении произошла ошибка' })
  }
}

export const updateGeoObject = (objId, data) => async function(dispatch) {
  dispatch({ type: 'UPDATE_GEO_OBJECT' })
  try {
    const geoObject = await fetchAPI(`/in/globe3d/geo-objects/${objId}`, 'PUT', data)
    dispatch({ type: 'UPDATE_GEO_OBJECT_SUCCESS', geoObject })
    sendNotification({ level: 'success', message: 'Объект успешно сохранен' })
    return geoObject
  } catch (error) {
    dispatch({ type: 'UPDATE_GEO_OBJECT_FAIL', error })
    sendNotification({ level: 'error', message: 'При сохранении произошла ошибка' })
  }
}

export const deleteGeoObject = (geoCategoryId, geoObjectId) => async function(dispatch) {
  dispatch({ type: 'DELETE_GEO_OBJECT' })
  try {
    await fetchAPI(`/in/globe3d/geo-objects/${geoObjectId}`, 'DELETE')
    dispatch({ type: 'DELETE_GEO_OBJECT_SUCCESS', geoCategoryId, geoObjectId })
    sendNotification({ level: 'success', message: 'Объект успешно удален' })
  } catch (error) {
    dispatch({ type: 'DELETE_GEO_OBJECT_FAIL', error })
    sendNotification({ level: 'error', message: 'При удалении произошла ошибка' })
  }
}
